import { ProfileManagement } from "@/components/ProfileManagement";
import { useNavigate } from "react-router-dom";

export const ProfilesPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <ProfileManagement onBack={handleBack} />;
};
